import {createManageDelete, createPage} from "../../../../../utils/page";
import {createLoading} from "../../../../../utils/loading";
import {reactive} from "vue";
import {createColumnInput} from "../../../../../components/table/c-table.logic";
import store from "../../../../../store";
import OperatorForm from "./OperatorForm"
import {onClickDeleteAll} from "../../../../../utils/form";
import {cloneDeep} from "lodash";
import i18n from '../../../../../i18n';

export const {isLoading, setIsLoading} = createLoading()

export const actionPrefix = 'resource/v1/master/labMonitorProductGroupTopic'
export const callSearch = ({criteria}) => store.dispatch(`${actionPrefix}/search`, {criteria})
export const callUpdateAll = ({data}) => store.dispatch(`${actionPrefix}/saveAll`, {data})
export const callDeleteAll = ({ids}) => store.dispatch(`${actionPrefix}/deleteAll`, {
    ids,
    config: {params: {isHardDelete: true}}
})

export const mapperState = reactive({
    columns: [
        createColumnInput({
            width: 70,
            title: () => i18n.global.t('lab.labTopic'),
            customRender: ({record}) => {
                let text = record.refLabTopic.nameS
                if (record.refLabTopic?.refLabTopicUnit) {
                    text += ` (${record.refLabTopic?.refLabTopicUnit?.value})`
                }
                return <div>{text}</div>
            },
            align: "center",
            search: {visible: () => false},
        }),
        createColumnInput({
            width: 70,
            title: () => i18n.global.t('lab.Formula.label'),
            customRender: ({record}) => <div>{record.refLabTopic?.refLabFormula?.key}</div>,
            align: "center",
            search: {visible: () => false},
        }),
        createColumnInput({
            width: 180,
            title: () => i18n.global.t('lab.labStandardTopic'),
            dataIndex: 'refLabTopic',
            customRender: ({record}) => {
                return <OperatorForm record={record}> </OperatorForm>
            },
            align: 'center',
            search: {visible: () => false},
        }),
    ],
    page: createPage({
        data: [],
        options: {
            select: []
        }
    }),
    tableOptions: {search: {activeKey: 'Search'}}
})

export const initMapperState = ({props}) => {
    const menuContext = props.menuContext
    const id = props.record.id
    const page = mapperState.page
    fetchTopics({mapperState, page, id})
    mapperState.manages = [
        createManageDelete({
            menuContext,
            onClick: ({rowSelection}) => onClickDeleteAll({
                rowSelection,
                callDeleteAll,
                state: {mapperState, page, id},
                onSearch: fetchTopics,
                setIsLoading
            }),
        })]
    mapperState.manageExtras = []
    mapperState.rowActions = []
}

export const fetchTopics = ({mapperState, page, id}) => {
    const where = page.where || []
    window.onSearch?.({page})
    setIsLoading(true)
    return callSearch({
        criteria: {
            ...page, data: [],
            select: ["**", "refLabTopic.refLabFormula.*", "refLabTopic.refLabTopicUnit.*"],
            page: 0,
            size: 10000,
            where: [...where, {name: 'refLabMonitorProductGroup.id', type: 'UUID', operator: '=', value: id}],
            sort: [{ name: 'refLabTopic.name', type: 'ASC' }],
        }
    }).then(page => {
        mapperState.page = {...page, where}

        mapperState.originalData = cloneDeep(page.data)
    }).catch(err => {
        console.log(err)
    }).finally(() => setIsLoading(false))
}
